import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import {
	Grid, Col, Nav, NavItem, Tab,
} from 'react-bootstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { isEqual, isEmpty } from 'lodash';
import { Link } from 'react-router-dom';
import constants from '@constants';
import { Loader, SubNavBar } from '@components/common';
import { DetailsJobList as JobList } from '@components';
import Actions, { thunks } from '@redux/coordinators';
import { jobColumns } from '@pages/locations/utils/columnsDefinition';
import locationsColumns from './utils/columnsDefinition';
import DetailsPanel from './components/detailsPanel';

class CoordinatorsDetails extends Component {
	UNSAFE_componentWillMount() {
		const { resetCoordinatorDetails } = this.props;
		resetCoordinatorDetails(['details']);
	}

	componentDidMount = () => {
		const {
			getDetailsData, getJobsData, getLocations, match : { params : { id } },
		} = this.props;
		getDetailsData(id);
		getJobsData('activeJobs');
		getJobsData('jobHistory');
		getLocations();
	}

	shouldComponentUpdate = ({
		detailsData,
		loading,
		activeJobsData,
		activeJobsTotalCount,
		activeJobsFilters,
		jobHistoryData,
		jobHistoryTotalCount,
		jobHistoryFilters,
		locationData,
		locationTotalCount,
		locationFilters,
	}) => {
		const lastProps = this.props;
		return (
			!isEqual(lastProps.detailsData, detailsData)
			|| !isEqual(lastProps.loading, loading)
			|| !isEqual(activeJobsData, lastProps.activeJobsData)
			|| !isEqual(activeJobsTotalCount, lastProps.activeJobsTotalCount)
			|| !isEqual(activeJobsFilters, lastProps.activeJobsFilters)
			|| !isEqual(jobHistoryData, lastProps.jobHistoryData)
			|| !isEqual(jobHistoryTotalCount, lastProps.jobHistoryTotalCount)
			|| !isEqual(jobHistoryFilters, lastProps.jobHistoryFilters)
			|| !isEqual(locationData, lastProps.locationData)
			|| !isEqual(locationTotalCount, lastProps.locationTotalCount)
			|| !isEqual(locationFilters, lastProps.locationFilters)
		);
	}

	handleOnClickBack = (event) => {
		event.preventDefault();
		const { history } = this.props;

		history.goBack();
	}

	jobsOnPaginate = (pageNumber, type) => {
		const {
			getLocations,
			getJobsData,
			updateJobListFilters,
		} = this.props;

		updateJobListFilters(type, { pageNumber });

		if (type === 'locations') getLocations();
		else getJobsData(type);
	}

	render() {
		const {
			loading,
			detailsData,
			activeJobsData,
			activeJobsTotalCount,
			activeJobsFilters,
			updateJobListFilters,
			jobHistoryData,
			jobHistoryTotalCount,
			jobHistoryFilters,
			locationData,
			locationTotalCount,
			locationFilters,
			TimeZoneId,
		} = this.props;
		return (
			<Fragment>
				<SubNavBar
					backText="Back to coordinators list"
					backButton
					onClickBack={this.handleOnClickBack}
				/>
				<If condition={!loading.details && !isEmpty(detailsData)}>
					<Grid className="margin-top-20 margin-bottom-20">
						<Col
							md={4}
						>
							<Choose>
								<When condition={detailsData.OrganizationTypeId === constants.ORGANIZATION_TYPE.LAW_ENFORCEMENT_DEPARTMENT}>
									<span className="color-dark font-light font-size-38">Agency Details</span>
								</When>
								<Otherwise>
									<span className="color-dark font-light font-size-38">Coordinator Details</span>
								</Otherwise>
							</Choose>
						</Col>
						<Col
							md={8}
						>
							<div className="padding-top-15 flex">
								<span className="color-dark font-bold font-size-20 flex-2">
									You and
									{ ` ${detailsData.Name}` }
								</span>
								<Link to="/reports" className="btn btn-primary">View Report</Link>
							</div>
						</Col>
					</Grid>
					<Grid>
						<Col
							md={4}
						>
							<DetailsPanel />
						</Col>
						<Col
							md={8}
						>
							<Tab.Container
								id="tabs"
								defaultActiveKey="active"
							>
								<div className="bg-white margin-top-10-mob">
									<Nav bsStyle="tabs">
										<NavItem
											key="active"
											eventKey="active"
										>
											Active Jobs (
											{ activeJobsTotalCount || 0 }
											)
										</NavItem>
										<NavItem
											key="history"
											eventKey="history"
										>
											Job History (
											{ jobHistoryTotalCount || 0 }
											)
										</NavItem>
										<NavItem
											key="locations"
											eventKey="locations"
										>
											Locations (
											{ locationTotalCount || 0 }
											)
										</NavItem>
									</Nav>
									<Tab.Content animation>
										<Tab.Pane
											eventKey="active"
											key="active"
										>
											<JobList
												type="activeJobs"
												jobColumns={() => jobColumns(TimeZoneId)}
												data={activeJobsData}
												totalCount={activeJobsTotalCount}
												filters={activeJobsFilters}
												loading={loading.activeJobs}
												onPaginate={this.jobsOnPaginate}
											/>
										</Tab.Pane>
										<Tab.Pane
											eventKey="history"
											key="history"
										>
											<JobList
												type="jobHistory"
												jobColumns={() => jobColumns(TimeZoneId)}
												data={jobHistoryData}
												totalCount={jobHistoryTotalCount}
												filters={jobHistoryFilters}
												loading={loading.jobHistory}
												onPaginate={this.jobsOnPaginate}
												resetJobHistoryFilters={() => updateJobListFilters('jobHistory', { pageNumber : 1 })}
											/>
										</Tab.Pane>
										<Tab.Pane
											eventKey="locations"
											key="locations"
										>
											<JobList
												type="locations"
												jobColumns={() => locationsColumns(TimeZoneId)}
												data={locationData}
												totalCount={locationTotalCount}
												filters={locationFilters}
												loading={loading.locations}
												onPaginate={this.jobsOnPaginate}
												tableHeaderNeeded
											/>
										</Tab.Pane>
									</Tab.Content>
								</div>
							</Tab.Container>
						</Col>
					</Grid>
				</If>
				<Loader active={loading.details} />
			</Fragment>
		);
	}
}

const mapStateToProps = ({
	coordinators : {
		details : {
			data : detailsData,
			activeJobs : {
				data       : activeJobsData,
				totalCount : activeJobsTotalCount,
				filters    : activeJobsFilters,
			},
			jobHistory : {
				data       : jobHistoryData,
				totalCount : jobHistoryTotalCount,
				filters    : jobHistoryFilters,
			},
			locations : {
				data       : locationData,
				totalCount : locationTotalCount,
				filters    : locationFilters,
			},
		},
		loading,
	}, app: { user : { TimeZoneId } },
}) => ({
	detailsData,
	loading,
	activeJobsData,
	activeJobsTotalCount,
	activeJobsFilters,
	jobHistoryData,
	jobHistoryTotalCount,
	jobHistoryFilters,
	locationData,
	locationTotalCount,
	locationFilters,
	TimeZoneId,
});

const mapDispatchToProps = (dispatch) => ({
	getDetailsData          : bindActionCreators(thunks, dispatch).getDetailsData,
	getJobsData             : bindActionCreators(thunks, dispatch).getJobsData,
	getLocations            : bindActionCreators(thunks, dispatch).getLocations,
	updateJobListFilters    : bindActionCreators(Actions, dispatch).updateSectionFilters,
	resetCoordinatorDetails : bindActionCreators(Actions, dispatch).resetCoordinatorsValues,
});

CoordinatorsDetails.propTypes = {
	TimeZoneId : PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number,
	]),
	activeJobsData          : PropTypes.array,
	activeJobsFilters       : PropTypes.object,
	activeJobsTotalCount    : PropTypes.number,
	detailsData             : PropTypes.object,
	getDetailsData          : PropTypes.func.isRequired,
	getJobsData             : PropTypes.func.isRequired,
	getLocations            : PropTypes.func.isRequired,
	history                 : PropTypes.object.isRequired,
	jobHistoryData          : PropTypes.array,
	jobHistoryFilters       : PropTypes.object,
	jobHistoryTotalCount    : PropTypes.number,
	loading                 : PropTypes.object.isRequired,
	locationData            : PropTypes.array,
	locationFilters         : PropTypes.object,
	locationTotalCount      : PropTypes.number,
	resetCoordinatorDetails : PropTypes.func.isRequired,
	updateJobListFilters    : PropTypes.func.isRequired,
	match                   : PropTypes.object.isRequired,
};

CoordinatorsDetails.defaultProps = {
	TimeZoneId           : '',
	activeJobsData       : [],
	activeJobsFilters    : {},
	activeJobsTotalCount : 0,
	detailsData          : {},
	jobHistoryData       : [],
	jobHistoryFilters    : {},
	jobHistoryTotalCount : 0,
	locationData         : [],
	locationFilters      : {},
	locationTotalCount   : 0,
};

export default connect(mapStateToProps, mapDispatchToProps)(CoordinatorsDetails);
